/**
 * Live WhatsApp connection status badge for the header.
 *
 * - Hidden if whatsapp_connect module isn't enabled
 * - Subscribes to Firestore companies/{id}/settings/whatsapp
 * - Click → navigate to /whatsapp/connect
 */

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { doc, onSnapshot } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import { db } from '../config/firebase';
import { useAuth } from '../context/AuthContext';

const WhatsAppStatusBadge = () => {
  const { activeCompany, isModuleEnabled } = useAuth();
  const [status, setStatus] = useState({ connected: false });
  const navigate = useNavigate();

  useEffect(() => {
    if (!activeCompany?.id) return undefined;
    const ref = doc(db, 'companies', activeCompany.id, 'settings', 'whatsapp');
    const unsub = onSnapshot(ref, (snap) => {
      setStatus(snap.exists() ? snap.data() : { connected: false });
    }, () => {});
    return unsub;
  }, [activeCompany?.id]);

  if (!isModuleEnabled('whatsapp_connect')) return null;

  const connected = !!status?.connected;
  const phoneShort = status?.phoneNumber
    ? (status.phoneNumber.length > 10 ? '…' + status.phoneNumber.slice(-7) : status.phoneNumber)
    : null;

  return (
    <Badge $connected={connected} onClick={() => navigate('/whatsapp/connect')} title={connected ? `Connected as ${status.phoneNumber}` : 'WhatsApp not connected — click to connect'}>
      <FaWhatsapp />
      <Dot $on={connected} />
      <Text>{connected ? phoneShort || 'Connected' : 'WA off'}</Text>
    </Badge>
  );
};

export default WhatsAppStatusBadge;

const Badge = styled.button`
  display: inline-flex; align-items: center; gap: 6px;
  background: ${p => p.$connected ? '#e8f5e9' : '#fdecea'};
  color: ${p => p.$connected ? '#1b5e20' : '#b00020'};
  border: 1px solid ${p => p.$connected ? '#a5d6a7' : '#f5c6cb'};
  border-radius: 14px; padding: 4px 10px; cursor: pointer;
  font-size: 12px; font-weight: 600;
  &:hover { filter: brightness(0.97); }
`;
const Dot = styled.div`
  width: 8px; height: 8px; border-radius: 50%;
  background: ${p => p.$on ? '#25D366' : '#bdbdbd'};
`;
const Text = styled.span`white-space: nowrap; font-family: monospace; font-size: 11px;`;
